import { Client } from './client';
import {
  CreateEquipmentGroupRequest,
  EquipmentGroupListResponse,
  EquipmentGroupResponse,
} from '@/types/equipmentGroupTypes';

export class EquipmentGroupController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  readByProcedureInstanceId(procedureInstanceId: string): Promise<EquipmentGroupListResponse> {
    return this.client.read(`/api/equipment-groups/procedure-instance/${procedureInstanceId}`);
  }

  create(body: CreateEquipmentGroupRequest): Promise<EquipmentGroupResponse> {
    return this.client.create('/api/equipment-groups', body);
  }
}
